import { useState } from "react";
import Input from "../../../../../../../components/Input";
import InputSelect from "../../../../../../../components/Input-select";
import { getClientsOfCollaborator } from "../../../service";
import { listPhysicalLocation, listStatus } from "../../constants";
import useEletronicInventoryStore from "../../store/useStore";

export default function RowSevenAndEight() {
  const { defaultValues, listUsers, token } = useEletronicInventoryStore();
  const { setDefaultValues, saveDataOfField, setState } = useEletronicInventoryStore();
  const [placeholderClient, setPlaceholderClient] = useState("");

  function handleStatus(event) {
    const SELECT_VALUE = event.target.value;
    const data = {
      ...defaultValues,
      status: SELECT_VALUE,
      isDeleted: verefyStatus(SELECT_VALUE),
    };
    setState(verefyStatus(SELECT_VALUE));
    setDefaultValues(data);
  }

  function verefyStatus(SELECT_VALUE) {
    if (SELECT_VALUE === "Disponível" || SELECT_VALUE === "Alocado") return false;
    return true;
  }

  async function handleChangeCollaborator(event) {
    const idUser = event.target.value;
    const clientsByUser = await getClientByUser(idUser);
    const data = {
      ...defaultValues,
      client: clientsByUser,
      userId: idUser,
    };
    definePlaceholderClient(clientsByUser);
    setDefaultValues(data);
  }

  function definePlaceholderClient(clientsByUser) {
    if (!clientsByUser?.length) return setPlaceholderClient("Esse profissional não está conectado a nenhum cliente");
    return setPlaceholderClient("");
  }

  async function getClientByUser(idUser: number | string) {
    const clientsByUser = await getClientsOfCollaborator(token, idUser);
    const cleanClientsList = clientsByUser?.map((client) => client)?.filter(Boolean);
    return cleanClientsList;
  }

  return (
    <>
      <div className="box-row">
        <InputSelect
          className="labelControllerSize"
          name="physicalLocation"
          label="Local Físico"
          placeholder="Local Físico"
          value={defaultValues?.physicalLocation}
          onChange={(event) => saveDataOfField(event.target)}
          list={listPhysicalLocation}
        />
        <InputSelect
          className="labelControllerSize"
          name="status"
          label="Status do Bem"
          placeholder="Status do Bem"
          value={defaultValues?.status}
          onChange={(event) => handleStatus(event)}
          list={listStatus}
        />
      </div>
      {defaultValues?.status === "Alocado" && (
        <div className="box-row">
          <InputSelect
            className="labelControllerSize"
            name="userId"
            label="Profissional"
            placeholder="Selecione o profissional"
            value={defaultValues?.userId}
            onChange={(event) => handleChangeCollaborator(event)}
            list={listUsers}
          />
          <Input
            name="client"
            label="Cliente"
            placeholder={placeholderClient || "Nome do Cliente"}
            value={defaultValues?.client}
            setValue={(event) => saveDataOfField(event.target)}
            disabled={true}
          />
        </div>
      )}
    </>
  );
}
